import React from 'react'
import { any, node, func, bool, object, string } from 'prop-types'
import styled from 'styled-components'

import { NavContextProvider } from '../../contexts/NavContext'
import { Logo } from '../../icons'
import { baseTiltifyUrl } from '../../utils'
import { UserMenu } from '../UserMenu'
import { Authentication } from '../Authentication'
import { NAV_TYPES } from './navTypes'

const StyledNav = styled.div`
  background-color: ${({ theme }) => theme.backgroundAccent};
  color: ${({ theme }) => theme.textColor};
`

const StyledNavWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  ${({ theme, fullWidth }) => `
       padding-left: 0.875rem;
       padding-right: 0.875rem;
       ${!fullWidth ? `max-width: ${theme.contentMaxWidth};` : ''}
       `}

  @media ${({ theme }) => `(max-width: ${theme.contentMaxWidth})`} {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }
  margin: auto;
`

const StyledNavChildren = styled.div`
  display: none;

  a {
    color: ${({ theme }) => theme.textColor};
  }

  @media ${({ theme }) => `(min-width: ${theme.breakpoints[0]})`} {
    display: flex;
  }
`

const StyledLogo = styled(({ logoColor, ...rest }) => <Logo {...rest} />)`
  path {
    fill: ${({ theme, logoColor }) => logoColor || theme.logoColor};
  }
`

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Nav = ({
  authentication,
  childrenLeft,
  childrenRight,
  forceAuth = false,
  fullWidth = false,
  ignoreAuth = false,
  logo,
  logoColor,
  navType = NAV_TYPES.frontend,
  preview = false,
  url,
  userMenuData,
  ...rest
}) => {
  const logoUrl = url || baseTiltifyUrl()
  const RenderAuthentication = authentication || Authentication

  return (
    <header id='gtm_header'>
      <NavContextProvider>
        <StyledNav {...rest}>
          <StyledNavWrapper fullWidth={fullWidth}>
            {!ignoreAuth && RenderAuthentication && (
              <RenderAuthentication forceAuth={forceAuth} preview={preview} />
            )}
            <Flex>
              {logo || (
                <a href={logoUrl} aria-label='Home'>
                  <StyledLogo title='Home' logoColor={logoColor} />
                </a>
              )}
              {childrenLeft ? <StyledNavChildren as='nav'>{childrenLeft}</StyledNavChildren> : null}
            </Flex>
            <nav id='gtm_nav'>
              <Flex>
                {childrenRight ? <StyledNavChildren>{childrenRight}</StyledNavChildren> : null}
                <UserMenu
                  childrenLeft={childrenLeft}
                  childrenRight={childrenRight}
                  navType={navType}
                  preview={preview}
                  userMenuData={userMenuData}
                />
              </Flex>
            </nav>
          </StyledNavWrapper>
        </StyledNav>
      </NavContextProvider>
    </header>
  )
}

Nav.propTypes = {
  authentication: func,
  childrenLeft: any,
  childrenRight: any,
  forceAuth: bool,
  fullWidth: bool,
  ignoreAuth: bool,
  logo: node,
  logoColor: string,
  navType: string,
  preview: bool,
  url: string,
  userMenuData: object,
}
